export const createCurrencyFormatter = (showHalfOwnership: boolean) => {
  const applyOwnershipSplit = (value: number): number => {
    return showHalfOwnership ? value / 2 : value;
  };

  return (value: number, compact = false) => {
    const adjustedValue = applyOwnershipSplit(value);
    if (compact && Math.abs(adjustedValue) >= 1000000) {
      return `$${(adjustedValue / 1000000).toFixed(1)}M`;
    }
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(adjustedValue);
  };
};

export const formatPercentage = (value: number, decimals = 1): string => {
  return `${value.toFixed(decimals)}%`;
};